import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 250 250",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { transform: "matrix(10.416666666666666,0,0,10.416666666666666,0,0)" }, [
      _createElementVNode("path", {
        d: "M19.6,8.75a6.93,6.93,0,0,0-2-.27c-1.24-.06-2.78-.06-3.68,0l0-.15c.42-2.17,3-10.26.75-7.84l-1,1.1c-2.52,2.89-8.55,10-9.44,11.4a.45.45,0,0,0,.15.69,1.6,1.6,0,0,0,.7.18c1,.07,3.34,0,4.41.06a3,3,0,0,1-.11.46c-.55,1.92-2.25,6.22-3,8.18l-.35.92a.44.44,0,0,0,.17.53c.4.16.47-.31.71-.9.52-1.29,1.69-4.11,2.53-6.33a22.93,22.93,0,0,0,.94-2.83.81.81,0,0,0-.07-.65.39.39,0,0,0-.26-.18A2.23,2.23,0,0,0,9.55,13c-.92-.06-2.93,0-4.05-.12,1.56-2,6.19-7.34,8.62-10.08-.45,1.76-1,4.06-1.27,5.27a4,4,0,0,0-.09.93.58.58,0,0,0,.21.4.51.51,0,0,0,.56.11c.1,0,1.88-.06,3.43,0l1.62,0-.57.79c-2.09,2.83-7,9.14-9.75,12.09a.3.3,0,0,0,0,.42.3.3,0,0,0,.43,0c2.79-2.91,7.89-9.14,10.06-11.93.47-.61.8-1.06.95-1.28A.62.62,0,0,0,19.6,8.75Z",
        style: {"fill":"#86bd4d","fill-rule":"evenodd"}
      })
    ], -1)
  ])))
}
export default { render: render }